(function ($) {
  'use strict';
  $(function () {
    $(".search__icon").on("click", function () {
      $(this).hide();
      $(this).closest(".search").find(".search__form").addClass("search__form_active");
    });

    $(".search__close").on("click", function () {
      $(this).closest(".search__form").removeClass("search__form_active");
      $(this).closest(".search").find(".search__icon").show();
    });
  });
})(jQuery);
